import React from 'react';
import CMSPage from '../../components/CMSPage/CMSPage';

const ContactUsPage = () => {
  return <CMSPage pageType="contact-us" />;
};

export default ContactUsPage;
